import "./App.css";
import { Fragment, useState, useEffect } from "react";
import { ThemeProvider, Box } from "@mui/material";
import { lightTheme, darkTheme } from "./theme";
import { Authentication } from "./routes/Authentication";
import { Main } from "./routes/Main";
import { QrCodeScreen } from "./pages/QrCode/QrCodeScreen";
import { OpenRoutes } from "./routes/Open";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastProvider, AuthProvider } from "./context";

function AdminApp() {
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.setItem("userLeaveTime", new Date().toISOString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <AuthProvider>
      <ToastProvider>
        <Main />
        <Authentication />
      </ToastProvider>
    </AuthProvider>
  );
}

function App() {
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    console.log("🚀 ~ App version: 1.0.0.24.2, 02 Dec 2024");
  }, []);

  return (
    <Fragment>
      <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
        <Box
          sx={{
            minHeight: "99vh",
          }}
        >
          <Router>
            <Routes>
              <Route path="/qrcode" element={<QrCodeScreen />} />
              <Route path="/open/*" element={<OpenRoutes />} />
              <Route path="*" element={<AdminApp />} />
            </Routes>
          </Router>
        </Box>
      </ThemeProvider>
    </Fragment>
  );
}

export default App;
